import React, { Component } from 'react';
import { Modal, Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { accessory } from '../../../../models/products';
import i18n from '../../../../i18n';
import Image from '../../../image';

export default class AccessoryModalView extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    data: accessory,
  };

  render() {
    const { isModalOpen, closeModal, data } = this.props;

    if (!data) return null;

    return (
      <Modal show={isModalOpen} onHide={closeModal}>
        <Modal.Header closeButton />
        <Modal.Body className="px-5 pb-5">
          <Row>
            <Col xs={4}>
              <Image
                className="mw-100"
                imageName={data.picture_file_name}
                alt="accessory"
                fallbackImg="empty_image_big.png"
              />
            </Col>
            <Col xs={8}>
              <h2 className="mb-3">{data.desc}</h2>
              <p>
                <strong>
                  {i18n.t('priceRequest.productModals.accessory.price')}{' '}
                </strong>
                {data.net_price &&
                  `${String(data.net_price).replace(
                    /(.)(?=(\d{3})+$)/g,
                    '$1 '
                  )} HUF`}
              </p>
            </Col>
          </Row>
          <p>
            <strong>
              {i18n.t('priceRequest.productModals.accessory.description')}
            </strong>
          </p>
          <p>{data.desc}</p>
          <Col xs={12} className="text-center">
            <Button
              variant="primary"
              onClick={closeModal}
              className="mt-1 mx-1"
            >
              {i18n.t('priceRequest.productModals.accessory.close')}
            </Button>
          </Col>
        </Modal.Body>
      </Modal>
    );
  }
}
